import { useEffect, useState } from 'react';
import { useHandleError, useStaffUnitDetails } from '@/hooks';

export const useStaffUnitData = (staffId: number) => {
  const handleError = useHandleError();
  const [isPageLoading, setIsPageLoading] = useState(true);

  const {
    data: staffUnitDetails,
    isLoading: isStaffUnitDetailsLoading,
    error: staffUnitDetailsError,
  } = useStaffUnitDetails(staffId);

  handleError([staffUnitDetailsError]);

  useEffect(() => {
    setIsPageLoading(isStaffUnitDetailsLoading);
  }, [isStaffUnitDetailsLoading]);

  return {
    staffUnitDetails,
    isPageLoading,
    staffUnitDetailsError,
  };
};
